import { render, staticRenderFns } from "./Waizi.vue?vue&type=template&id=1abcb17c&scoped=true&"
import script from "./Waizi.vue?vue&type=script&lang=js&"
export * from "./Waizi.vue?vue&type=script&lang=js&"
import style0 from "./Waizi.vue?vue&type=style&index=0&id=1abcb17c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abcb17c",
  null
  
)

export default component.exports